import * as yup from "yup"

export default yup.object().shape({
    email: yup
        .string()
        .email("Niepoprawna forma adresu email")
        .required("To pole jest wymagane"),
    password: yup.string().required("To pole jest wymagane")
})
